import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { ModalCloseButton } from '../ModalCloseButton';
import styles from './ModalHeader.css';

const cx = classnames.bind(styles);

function ModalHeader({
    className,
    title,
    onClose
}) {
    const classes = cx({
        root: true,
        [className]: className
    });

    return (
        <div className={classes}>
            <p className={styles.title}>
                {title}
            </p>
            {Boolean(onClose) && <ModalCloseButton onClick={onClose} />}
        </div>
    )
}

ModalHeader.defaultProps = {
    className: '',
    onClose: null
}

ModalHeader.propTypes = {
    className: PropTypes.string,
    onClose: PropTypes.func,
    title: PropTypes.string.isRequired
}

export {
    ModalHeader
}
